import { render } from "./socialResponsibility.vue?vue&type=template&id=3cdcc734&scoped=true"
import script from "./socialResponsibility.vue?vue&type=script&lang=js"
export * from "./socialResponsibility.vue?vue&type=script&lang=js"

import "./socialResponsibility.vue?vue&type=style&index=0&id=3cdcc734&scoped=true&lang=css"
import "./socialResponsibility.vue?vue&type=style&index=1&id=3cdcc734&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdcc734"]])

export default __exports__